import { MutationTree } from "vuex";
import { IPagination } from "@/types";
import { CostState, ICost } from "@/types/cost";

const mutations: MutationTree<CostState> = {
  pagination: (state, costs: IPagination<ICost[]>) => {
    state.pagination = costs;
  },
  single: (state, cost: ICost) => {
    state.cost = cost;
  },
  remove: (state, cost_id: number) => {
    if (state.pagination) {
      const filterdCost = state.pagination.data.filter(cost => {
        return cost.id !== cost_id;
      });
      state.pagination.data = filterdCost;
    }
  },
  clear: state => {
    state.cost = undefined;
    state.pagination = undefined;
  },
  amount: (state, amount) => (state.amount = amount),
  volume: (state, volume) => (state.volume = volume)
};

export default mutations;
